import * as React from 'react';

class ElectricEnergySvg extends React.Component<Svg.IProps, Svg.IState> {
  static defaultProps: Svg.IProps = { className: '' };

  render() {
    const { className, ...rest } = this.props;

    return (
      <svg
        viewBox="0 0 28 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`svg-icon electric-energy-svg ${className || 'm-3'}`}
        {...rest}
      >
        <path
          d="M27.3542 19.4374L9.64582 44.4374C9.52841 44.6888 9.31593 44.8832 9.05514 44.978C8.79435 45.0727 8.5066 45.06 8.2552 44.9426C8.00379 44.8252 7.80933 44.6127 7.71458 44.3519C7.61984 44.0911 7.63258 43.8034 7.74999 43.552L12.625 26.1249H1.49999C1.31152 26.1258 1.12633 26.0756 0.964163 25.9795C0.801994 25.8835 0.668918 25.7452 0.579117 25.5795C0.489317 25.4138 0.446156 25.2269 0.454234 25.0386C0.462312 24.8503 0.521327 24.6677 0.624989 24.5103L16.25 0.551963L16.3125 0.458213C16.4002 0.348926 16.5091 0.258462 16.6326 0.192237C16.7561 0.126012 16.8917 0.0853877 17.0312 0.0727951H17.125C17.2867 0.0676351 17.4475 0.100232 17.5944 0.168C17.7414 0.235767 17.8705 0.336841 17.9716 0.463208C18.0727 0.589574 18.143 0.737758 18.1768 0.896005C18.2107 1.05425 18.2072 1.21821 18.1667 1.37488L15.2396 17.7915H26.5C26.6917 17.7905 26.88 17.8424 27.0441 17.9415C27.2083 18.0407 27.3419 18.1832 27.4302 18.3534C27.5185 18.5235 27.5581 18.7148 27.5447 18.9061C27.5313 19.0973 27.4654 19.2812 27.3542 19.4374Z"
          fill="white"
        />
      </svg>
    );
  }
}

export default ElectricEnergySvg;
